import DragHandleIcon from '@mui/icons-material/DragHandle';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';

import { Checkbox } from '../../../Checkbox/Checkbox';

export const StyledCheckbox = styled(Checkbox)`
  padding-right: 0;
`;

export const StyledDragHandleIcon = styled(DragHandleIcon)`
  cursor: grab;
`;

export const StyledMenuItem = styled(MenuItem)`
  gap: ${({ theme }) => theme.spacing(1.5)};
`;
